import React, {ReactNode} from 'react';

// components
import {Footer} from '../Footer';
import {WarningBanner} from '../WarningBanner';
// styles
import {
  PageTemplateChildrenWrapper,
  PageTemplateContent,
  PageTemplateWrapper,
  TitleSubtitleWrapper,
} from './PageTemplate-styles';
import {TextColors, TextDefault, TitleExtraLarge} from '../../styles';

// hooks
import {useWarningBanner} from '../../hooks';

// types
type Props = {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  showWarningBanner?: boolean;
};

const PageTemplate = ({
  children,
  title,
  subtitle,
  showWarningBanner = false,
}: Props) => {
  const shouldShowBanner = useWarningBanner();
  const displayBanner = showWarningBanner && shouldShowBanner;

  return (
    <PageTemplateWrapper>
      <PageTemplateContent>
        {displayBanner && <WarningBanner shouldShow={true} />}
        {(title || subtitle) && (
          <TitleSubtitleWrapper>
            {title && <TitleExtraLarge>{title}</TitleExtraLarge>}
            {subtitle && (
              <TextDefault color={TextColors.secondary}>{subtitle}</TextDefault>
            )}
          </TitleSubtitleWrapper>
        )}
        <PageTemplateChildrenWrapper>{children}</PageTemplateChildrenWrapper>
      </PageTemplateContent>
      <Footer />
    </PageTemplateWrapper>
  );
};

export default PageTemplate;
